import React, { useEffect, useState } from 'react';
import MetricCard from './MetricCard';
import { convertNumberToThousand, handleFloatInt } from '../../utils';
import { mockProcessedDashboardData } from '../../utils/mock';
import { useApp } from '../../context/AppContext';
import InnerLoader from '../microComponents/InnerLoader';
import FarmSelector from '../microComponents/FarmSelector';
import OrganizationSelector from '../microComponents/OrganizationSelector';

const Summary = () => {
    const { user, loading, graphsData } = useApp();

    const [dashboardData, setDashboardData] = useState([]);

    useEffect(() => {
        if (graphsData.length === 0) {
            setDashboardData(mockProcessedDashboardData)
            return;
        }

        const questionsData = graphsData;

        const totalAcreage = questionsData.find(question => question.order === "10")

        if (totalAcreage) {
            // Get detials of the question at order 2
            const questionDetailsOne = questionsData.find(question => question.order === "10");
            // const convertedLand = questionDetailsOne?.answer ?
            //     (((totalAcreage.answer || 0) * (questionDetailsOne.answer || 0)) / 100).toFixed(2) : 0;

            if (questionDetailsOne) {
                // console.log('value - ', convertedLand, questionDetailsOne)
                setDashboardData([{
                    title: 'REGENRATIVE AGRICULTURE',
                    value: convertNumberToThousand(questionDetailsOne?.answer?.toString() || '0') + ' acres',
                    description: 'of Land Converted to Regenerative Agricultural Practice',
                    backgroundColor: '#e9bd52'
                }])
            }
        }

        // Get detials of the question at order 3
        const questionDetailsTwo = questionsData.find(question => question.order === "3");
        if (questionDetailsTwo) {
            setDashboardData(prevData => [...prevData, {
                title: 'WELLBEING',
                value: (handleFloatInt(questionDetailsTwo?.average || 0)) + '%',
                description: 'Reduction in Fertilizer & Pesticide Use',
                backgroundColor: '#39bf90'
            }])
        }

        // Get detials of the question at order 4
        const questionDetailsThree = questionsData.find(question => question.order === "4");
        if (questionDetailsThree) {
            setDashboardData(prevData => [...prevData, {
                title: 'Water Restoration',
                value: convertNumberToThousand((questionDetailsThree?.answer || 0).toString()),
                description: 'Gallons of Water Restored',
                backgroundColor: '#9968ea'
            }])
        }

        // Get detials of the question at order 5
        const questionDetailsFour = questionsData.find(question => question.order === "5");
        if (questionDetailsFour) {
            setDashboardData(prevData => [...prevData, {
                title: 'Renewable Energy',
                value: (questionDetailsFour?.answer ? handleFloatInt(questionDetailsFour.answer) : 0) + '%',
                description: 'Energy Across our Farms Comes From Renewable Sources',
                backgroundColor: '#ef638a'
            }])
        }

        // Get detials of the question at order 6
        const questionDetailsFive = questionsData.find(question => question.order === "6");
        if (questionDetailsFive) {
            setDashboardData(prevData => [...prevData, {
                title: 'Animal Welfare',
                value: (questionDetailsFive?.answer ? handleFloatInt(questionDetailsFive.answer) : 0),
                description: 'Procurment from farms that Follow Animal Welfare Standards',
                backgroundColor: '#e9bd52'
            }])
        }

        // Get detials of the question at order 7
        const questionDetailsSix = questionsData.find(question => question.order === "7");
        if (questionDetailsSix) {
            setDashboardData(prevData => [...prevData, {
                title: 'Socio-Economic Diversity',
                value: (questionDetailsSix?.answer ? handleFloatInt(questionDetailsSix.answer) : 0) + '%',
                description: 'Procurment form Different Ethinic and Socio Economic Groups',
                backgroundColor: '#39bf90'
            }])
        }

        // Get detials of the question at order 9
        const questionDetailsSeven = questionsData.find(question => question.order === "9");
        if (questionDetailsSeven) {
            setDashboardData(prevData => [...prevData, {
                title: 'Trainings',
                value: convertNumberToThousand(questionDetailsSeven?.answer ? handleFloatInt(questionDetailsSeven.answer) : 0),
                description: 'Farmer Trainings Delivered',
                backgroundColor: '#9968ea'
            }])
        }
    }, [graphsData])

    return (
        <div className="p-8">
            <div className="mb-8 flex flex-row justify-between items-center gap-4">
                <h1 className="text-2xl font-bold flex flex-row gap-2">
                    Summary {loading && <InnerLoader
                        divSize={{ width: "30px", height: "30px" }}
                        loaderSize={{ width: "28px", height: "28px" }}
                    />}
                </h1>
                <div className="flex gap-4">
                    {user?.role === 'super_admin' && (
                        <>
                            <FarmSelector />
                            <OrganizationSelector />
                        </>
                    )}
                    {user?.role === 'admin' && (
                        <FarmSelector />
                    )}
                </div>
            </div>
            {!loading && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {dashboardData && dashboardData.length > 0 && dashboardData.map((card, index) => (
                    <MetricCard
                        key={index}
                        title={card.title}
                        value={card.value}
                        description={card.description}
                        backgroundColor={card.backgroundColor}
                        className="metric-card-animate"
                    />
                ))}
                {graphsData && graphsData?.length > 0 && <div
                    className={`rounded-xl p-6 text-white transition-transform hover:scale-105 lg:col-span-2 metric-card-animate`}
                    style={{
                        minHeight: '160px',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#4a90e2',
                        boxShadow: `0px 25px 30px -30px #4a90e2`
                    }}
                >
                    <div className="text-sm font-medium opacity-80 uppercase tracking-wide flex flex-col justify-start items-start">
                        Socio-Demographics
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        {graphsData[0]?.answer.map((item, index) => (
                            (
                                <div key={index} className="flex justify-between items-center">
                                    <span>{item.value}:</span>
                                    <span className="font-medium">{item?.option_average?.toFixed(1) || 0}%</span>
                                </div>
                            )
                        ))}
                    </div>
                </div>}
            </div>
            }
        </div>
    );
};

export default Summary; 